import { render } from "./Payouts.vue?vue&type=template&id=b8e71e08&scoped=true&ts=true"
import script from "./Payouts.vue?vue&type=script&lang=ts"
export * from "./Payouts.vue?vue&type=script&lang=ts"

import "./Payouts.vue?vue&type=style&index=0&id=b8e71e08&lang=scss&scoped=true"

import exportComponent from "/root/source/core/frontend/affiliate/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b8e71e08"]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QTable from 'quasar/src/components/table/QTable.js';
import QTd from 'quasar/src/components/table/QTd.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn,QTable,QTd});
